(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-cross-sell"]) return;
  try {
    
  if (!customElements.get('floating-cross-sell')) {
    customElements.define('floating-cross-sell', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-floating-cross-sell-close]')?.addEventListener('click', () => this.dismiss());
        this.loadRecommendation();
      }

      async loadRecommendation() {
        const card = await this.fetchRecommendation('complementary') || await this.fetchRecommendation('related');
        if (!card || !this.isConnected) return;
        if (card.dataset.recommendationIntent === 'related') {
          this.querySelector('[data-floating-cross-sell-heading]').textContent = this.dataset.relatedHeading;
          this.setAttribute('aria-label', this.dataset.relatedHeading);
        }
        this.querySelector('[data-floating-cross-sell-content]').replaceChildren(card);
        this.observeBenefits();
      }

      async fetchRecommendation(intent) {
        const url = new URL(this.dataset.recommendationsUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('product_id', this.dataset.productId);
        url.searchParams.set('limit', '1');
        url.searchParams.set('intent', intent);
        try {
          const response = await fetch(url);
          if (!response.ok) return null;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          return html.querySelector('[data-floating-cross-sell-item]');
        } catch {
          return null;
        }
      }

      observeBenefits() {
        const heading = [...document.querySelectorAll('main h2, main h3')]
          .find(element => element.textContent.trim().toLowerCase() === 'benefits');
        const target = heading?.closest('.shopify-section');
        if (target) {
          if (target.getBoundingClientRect().bottom < 0) {
            this.show();
            return;
          }
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.show();
            }
          }, { threshold: 0.05 });
          this.observer.observe(target);
        } else {
          const onScroll = () => {
            if (window.scrollY > Math.max(window.innerHeight, document.documentElement.scrollHeight * 0.35)) {
              window.removeEventListener('scroll', onScroll);
              this.show();
            }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        }
      }

      show() {
        if (this.dismissed) return;
        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-visible'));
        document.body.classList.add('floating-cross-sell-active');
      }

      dismiss() {
        this.dismissed = true;
        this.classList.remove('is-visible');
        this.hidden = true;
        document.body.classList.remove('floating-cross-sell-active');
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.body.classList.remove('floating-cross-sell-active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pills-banner"] && !Shopify.designMode) return;
  try {
    
  // Use the Web Animations API to adjust playback rate on hover without jumping
  document.addEventListener('DOMContentLoaded', function() {
    var track = document.querySelector('#{{ section.id }} .pills-banner__track');
    if (!track) return;

    // When mouse enters the marquee, slow playback to half speed
    track.addEventListener('mouseenter', function() {
      track.getAnimations().forEach(function(anim) {
        anim.updatePlaybackRate(0.5);
      });
    });

    // When mouse leaves, restore normal speed
    track.addEventListener('mouseleave', function() {
      track.getAnimations().forEach(function(anim) {
        anim.updatePlaybackRate(1);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
